import { render, staticRenderFns } from "./SectionEditForm.vue?vue&type=template&id=c9faa4b0"
import script from "./SectionEditForm.vue?vue&type=script&lang=js"
export * from "./SectionEditForm.vue?vue&type=script&lang=js"
import style0 from "./SectionEditForm.vue?vue&type=style&index=0&id=c9faa4b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports